let moment = require('moment');


export let colSalaryAndBenefitsStartDate = {
                                                colId: 'salaryAndBenefitsStartDate',
                                                headerName: 'Salary and Benefits Start Date',
                                                field: 'startDate',
                                                width: 50,
                                                sortable: true,
                                                filterParams:   {comparator: dateComparator},
                                                comparator: dateComparator,
                                                cellRenderer: dateFormatter
                                            };

export let colSalaryAndBenefitsEndDate =    {
                                                colId: 'dalaryAndBenefitsEndDate',
                                                headerName: 'Salary and Benefits End Date',
                                                field: 'endDate',
                                                width: 50,
                                                sortable: true,
                                                filterParams:   {comparator: dateComparator},
                                                comparator: dateComparator,
                                                cellRenderer: dateFormatter
                                            };

export let colCMEAnnualAllowance =  {
                                        colId: 'cmeAnnualAllowance',
                                        headerName: 'CME Annual Allowance',
                                        field: 'cmeAnnualAllowance',
                                        width: 50,
                                        sortable: true
                                    };

export let colDBSAnnualAllowance =  {
                                            colId: 'dBSAnnualAllowance',
                                            headerName: 'DBS Annual Allowance',
                                            field: 'dbsAnnualAllowance',
                                            width: 50,
                                            sortable: true
                                        };

export let colStudentLoanAnnualReimbursement =  {
                                                    colId: 'studentLoanAnnualReimbursement',
                                                    headerName: 'Student Loan Annual Reimbursement',
                                                    field: 'studentLoanAnnualReimbursement',
                                                    width: 50,
                                                    sortable: true
                                                };



export let allColumns = [
    colSalaryAndBenefitsStartDate,
    colSalaryAndBenefitsEndDate,
    colCMEAnnualAllowance,
    colDBSAnnualAllowance,
    colStudentLoanAnnualReimbursement
];



export let columnSelectList = [
    {
        value: colSalaryAndBenefitsStartDate,
        viewValue: colSalaryAndBenefitsStartDate.headerName
    },
    {
        value: colSalaryAndBenefitsEndDate,
        viewValue: colSalaryAndBenefitsEndDate.headerName
    },
    {
        value: colCMEAnnualAllowance,
        viewValue: colCMEAnnualAllowance.headerName
    },
    {
        value: colDBSAnnualAllowance,
        viewValue: colDBSAnnualAllowance.headerName
    },
    {
        value: colStudentLoanAnnualReimbursement,
        viewValue: colStudentLoanAnnualReimbursement.headerName
    }
];




function  dateFormatter(params) {

    if (params.value == undefined) {
        return null;
    } else {
        let dateObject = moment(params.value);
        let friendlyDate = dateObject.format('ll');

        if (friendlyDate == 'Invalid date') {
            // console.log('invalid date: ', params.value);
            return params.value;
        } else {
            // console.log('valid date: ', friendlyDate);
            return friendlyDate;
        }
    }
}


function dateComparator(date1, date2) {

    if (date1 === null && date2 === null) {
          return 0;
    }

    if (date1 === null || date1 === undefined || date1 === '' || !date1 ) {
        return -1;
    }

    if (date2 === null || date2 === undefined || date2 === '' || !date2 ) {
        return 1;
    }    

    let date1AsMoment = moment(date1);
    let date2AsMoment = moment(date2);
    // let date1AsMoment = moment(date1, ["MM-DD-YYYY", "M-D-YYYY", "MM/DD/YYYY"]);
    // let date2AsMoment = moment(date2, ["MM-DD-YYYY", "M/D/YYYY", "MM/DD/YYYY"]);

    if (date1AsMoment.isValid() && date2AsMoment.isValid()) {

        // console.log(date1);

        if (date1AsMoment.isBefore(date2AsMoment)) {
            return -1;
        } else {
            return 1;
        }

    } else {
        // BUGBUG:  I don't know what this case means.
        
        // console.log('******* something is not a date');
        // console.log(date1);
        // console.log(typeof date1);
        // console.log(date1.length);
        // console.log(date2);
        // console.log(typeof date2);
        return 0;
    }

}